import { FC, PropsWithChildren, createContext, useCallback, useEffect, useState } from "react";
import { Auth, User } from "../@types/Auth";
import { RouteType } from "../@types/RouteType";
import { UserRoutes } from "../routes/UserRoutes";

const AuthContext = createContext<Auth | undefined>(undefined);

export const AuthProvider: FC<PropsWithChildren> = ({ children }) => {

    const [token, setToken] = useState<string | undefined>(undefined);

    const [user, setUser] = useState<User | undefined>(undefined);

    const [userAuthorizedRoutes, setUserAuthorizedRoutes] = useState<RouteType[]>([]);

    const logout = () => {

        setUser(undefined);

        setToken(undefined);

        localStorage.removeItem('MJDP-ath');

    }

    useEffect(() => {

        try {

            if (token) {

                localStorage.setItem('MJDP-ath', `${token}`);

            }

        } catch (error) {

            console.error(error);

        }

    }, [token]);

    useEffect(() => {

        /*
            i.e. check if user role = 'admin' 
            and assign the correct routes based on 
            that role.  routes based on a role should be added to src/routes/index.tsx
        */
        if (user) {

            const filteredUserRoutes = UserRoutes.filter((route) => route.authorizedRoles.includes(user.attributes.type));

            setUserAuthorizedRoutes(filteredUserRoutes);

        }

    }, [user, setUserAuthorizedRoutes]);

    return (

        <AuthContext.Provider

            value={{

                token,

                setToken,

                user,

                setUser,

                logout,
                
                userAuthorizedRoutes,
                
                setUserAuthorizedRoutes

            }}>

            {children}

        </AuthContext.Provider>

    )

}

export default AuthContext;